module.exports = __webpack_public_path__ + "img/checkbox-check.b350cd49.svg";